import type { RealtimeChannel } from '@supabase/supabase-js';
import { useRef, useEffect, useState } from 'react';

import { supabase } from '../../../lib/supabase';

export function useRoomChannel(roomId: string): RealtimeChannel | null {
  const channelRef = useRef<RealtimeChannel | null>(null);
  const [channel, setChannel] = useState<RealtimeChannel | null>(null);

  useEffect(() => {
    if (!roomId) return;
    if (channelRef.current) return; // Already created

    const channel = supabase.channel(`multiplayer-room-${roomId}`);
    channel.subscribe();
    channelRef.current = channel;
    setChannel(channel);

    return () => {
      if (channelRef.current) {
        channelRef.current.unsubscribe();
        channelRef.current = null;
      }
      setChannel(null);
    };
  }, [roomId]);

  return channel;
}
